export const Roles = {
  Admin: 'Admin',
  HR: 'Nhân sự',
  Accountant: 'Kế toán',
  Employee: 'Công nhân'
} as const;

export const Permissions = {
  // Role
  RoleView: 'role.view',
  RoleCreate: 'role.create',
  RoleEdit: 'role.edit',
  RoleDelete: 'role.delete',

  // User permissions
  UserView: 'user.view',
  UserCreate: 'user.create',
  UserEdit: 'user.edit',
  UserDelete: 'user.delete',

  // Employee permissions
  EmployeeView: 'employee.view',
  EmployeeCreate: 'employee.create',
  EmployeeEdit: 'employee.edit',
  EmployeeDelete: 'employee.delete',
  EmployeeExport: 'employee.export',
  EmployeeImport: 'employee.import',
  EmployeeGenerateAccount: 'employee.generateAccount',
  EmployeeViewBalance: 'employee.viewBalance',
  EmployeeEditBalance: 'employee.editBalance',
  EmployeeDeleteBalance: 'employee.deleteBalance',

  // Company permissions
  CompanyView: 'company.view',
  CompanyCreate: 'company.create',
  CompanyEdit: 'company.edit',
  CompanyDelete: 'company.delete',
  CompanySalary: 'company.salary',

  // EmployeeGroup permissions
  EmployeeGroupView: 'employeegroup.view',
  EmployeeGroupCreate: 'employeegroup.create',
  EmployeeGroupEdit: 'employeegroup.edit',

  // File Storage permissions
  FileStorageView: 'filestorage.view',
  FileStorageCreate: 'filestorage.create',
  FileStorageEdit: 'filestorage.edit',
  FileStorageDelete: 'filestorage.delete',
  FileStorageAdmin: 'filestorage.admin',

  // Personal permissions
  // PersonalView: 'personal.view',
  // PersonalEdit: 'personal.edit',
  // PersonalChangePassword: 'personal.changePassword',

  // Leave Tracking and Holiday Setting
  LeaveView: 'leave.view',
  LeaveCreate: 'leave.create',
  LeaveEdit: 'leave.edit',
  LeaveDelete: 'leave.delete',
  LeaveExport: 'leave.export',

  HolidayView: 'holiday.view',
  HolidayCreate: 'holiday.create',
  HolidayEdit: 'holiday.edit',
  HolidayDelete: 'holiday.delete',

  // Asset permissions
  AssetView: 'asset.view',
  AssetCreate: 'asset.create',
  AssetEdit: 'asset.edit',
  AssetDelete: 'asset.delete',
  AssetStockManage: 'asset.stock.manage',

  // Employee Asset permissions
  EmployeeAssetView: 'employeeasset.view',
  EmployeeAssetCreate: 'employeeasset.create',
  EmployeeAssetEdit: 'employeeasset.edit',
  EmployeeAssetDelete: 'employeeasset.delete',
  EmployeeAssetExport: 'employeeasset.export',

  // Employee Gift permissions
  EmployeeGiftView: 'employeegift.view',
  EmployeeGiftCreate: 'employeegift.create',
  EmployeeGiftEdit: 'employeegift.edit',
  EmployeeGiftDelete: 'employeegift.delete',
  EmployeeGiftExport: 'employeegift.export',

  // Employee Identity Card permissions
  EmployeeIdentifyCard: 'employee.identifycard',

  // Employee Profile Type permissions
  EmployeeProfileType: 'employee.profiletype',

  // Employee Working Status permissions
  EmployeeWorkingStatus: 'employee.workingStatus',
  EmployeeStoppedStatus: 'employee.stoppedStatus',

  // Employee Banned View permission
  EmployeeBannedView: 'employee.bannedView',

  // User Activity permissions
  UserActivityView: 'useractivity.view',
  UserActivityAdmin: 'useractivity.admin',

  // Request Ticket permissions
  RequestSalaryTicketManage: 'requestsalaryticket.manage',
  RequestTicketDelete: 'requestticket.delete',

  // Labor Contract permissions
  LaborContractView: 'laborcontract.view',
  LaborContractCreate: 'laborcontract.create',
  LaborContractEdit: 'laborcontract.edit',
  LaborContractDelete: 'laborcontract.delete',
  LaborContractFileView: 'laborcontract.file.view',
  LaborContractFileRegenerate: 'laborcontract.file.regenerate',

  // Dormitory Management permissions
  DormitoryView: 'dormitory.view',
  DormitoryCreate: 'dormitory.create',
  DormitoryEdit: 'dormitory.edit',
  DormitoryDelete: 'dormitory.delete',
  DormitoryAssign: 'dormitory.assign',
  DormitoryStatistics: 'dormitory.statistics',

  // Employee Portal
  EmployeePortal: 'employee.portal',

  // Accounting Transaction permissions
  AccountingTransactionView: 'accountingtransaction.view',
  AccountingTransactionCreate: 'accountingtransaction.create',
  AccountingTransactionEdit: 'accountingtransaction.edit',
  AccountingTransactionDelete: 'accountingtransaction.delete',
  AccountingTransactionExport: 'accountingtransaction.export',
  AccountingTransactionVerify: 'accountingtransaction.verify',
  AccountingTransactionApprove: 'accountingtransaction.approve',

  BusinessPlanSettingView: 'businessplansetting.view',
  BusinessPlanSettingCreate: 'businessplansetting.create',
  BusinessPlanSettingEdit: 'businessplansetting.edit',
  BusinessPlanSettingDelete: 'businessplansetting.delete',

  // Transaction Category permissions
  TransactionCategoryView: 'transactioncategory.view',
  TransactionCategoryCreate: 'transactioncategory.create',
  TransactionCategoryEdit: 'transactioncategory.edit',
  TransactionCategoryDelete: 'transactioncategory.delete',

  // Skill permissions
  SkillView: 'skill.view',
  SkillCreate: 'skill.create',
  SkillEdit: 'skill.edit',
  SkillDelete: 'skill.delete',

  // Custom Tag permissions
  CustomTagView: 'customtag.view',
  CustomTagCreate: 'customtag.create',
  CustomTagEdit: 'customtag.edit',
  CustomTagDelete: 'customtag.delete',

  // Payslip permissions
  // EmployeeViewBalance: 'payslip.view',
  PayrollGenerate: 'payroll.generate',
  PayrollVerify: 'payroll.verify',
  PayrollApprove: 'payroll.approve',
  PayrollDelete: 'payroll.delete',
} as const;